import { render, staticRenderFns } from "./ComUser.vue?vue&type=template&id=79ca29d7&scoped=true&"
import script from "./ComUser.vue?vue&type=script&lang=js&"
export * from "./ComUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca29d7",
  null
  
)

export default component.exports